<template>
  <div class="relative">
    <!-- v-for="(item, index) in 6" :key="index" -->
    <div class="sm-h390">
      <div class="absolute bg-design1 mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd1.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="absolute bg-design2 mob-hidden">
        <img src="../../../assets/images/bg-des/bgd2.svg" alt="bg-polygon" />
      </div>
      <div class="absolute bg-design3 mob-hidden">
        <img
          src="../../../assets/images/Ellipse 12.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="h-95per">
        <img
          src="../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="absolute h-550px sm-h-525px right-0"
        />
      </div>
      <div class="lg:px-20 md:px-20 px-5 items-center lg:flex md:flex h-470px">
        <!-- <img
          src="../../../assets/images/cp-bg.png"
          alt="cp bg"
          class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
        /> -->
        <div
          class="lg:w-1/2 md:w-1/2 w-full absolute md:hidden lg:hidden block lg:top-0 md:top-0 top-24"
        >
          <img
            src="../../../assets/images/swiper-img/home-mob-1.svg"
            class="w-full absolute md:hidden lg:hidden block"
            alt="swiper-img"
          />
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
          <div class="">
            <p
              class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
            >
              Shop
            </p>

            <p
              class="fsize25 sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
            >
              Buy products for stress free caregiving.

              <!-- <a
                class="underline text-4f0a4b min-hidden font-semibold cursor-pointer"
                >Know More</a
              > -->
            </p>
            <!-- <div class="flex lg:pt-8 md:pt-8 mob-hidden">
              <base-button
                @click="handleClick('')"
                type="primary"
                class="px-8 btntext"
                >Buy Now</base-button
              >
            </div> -->
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden h-550px">
          <img
            src="../../../assets/images/Product/ProductBanner.png"
            class="custborderradius mt-8"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div> -->

    <!-- <div
        class="swiper-pagination cust-posi dot-shift top97"
        slot="pagination"
      ></div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      editModal: false,
    };
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style scoped>
@media (min-width: 1024px) {
  .h-550px {
    height: 550px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.9);
    filter: hue-rotate(40deg);
  }

  .swiper-button-next {
    right: 55px !important;
  }

  .swiper-button-prev {
    left: 55px !important;
  }
  .h-470px {
    height: 470px;
  }
}
@media (max-width: 640px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.5);
    filter: hue-rotate(40deg);
  }
  .sm-h-banner {
    height: 210px;
    margin-top: 2rem;
    margin-left: 4rem;
  }
  .top97 {
    top: 97% !important;
  }
  .sm-h-525px {
    height: 480px !important;
  }
  .sm-h390 {
    height: 390px;
  }
}
.h-550px {
  height: 550px !important;
}
</style>
